import { render, staticRenderFns } from "./simAllOpen.vue?vue&type=template&id=5f88d936&scoped=true&"
import script from "./simAllOpen.vue?vue&type=script&lang=js&"
export * from "./simAllOpen.vue?vue&type=script&lang=js&"
import style0 from "./simAllOpen.vue?vue&type=style&index=0&id=5f88d936&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f88d936",
  null
  
)

export default component.exports